import React from 'react';
import blog1 from './blog1.png';
import blog2 from './blog2.png';
import blog3 from './blog3.png';

import SearchIcon from '@mui/icons-material/Search';
import css from './BlogSection.module.css';
import { useHistory } from 'react-router-dom';

const BlogSection = () => {
  const history = useHistory();
  return (
    <div className={css.wrapper}>
      <div className={css.content}>
        <div className={css.textWrapper}>
          <p className={css.title}>Scan stories</p>
          <p className={css.description}>
            Get inspired by the people behind the pixels. Our blog is packed with creative
            workflows, pro tips, and behind-the-scenes snapshots from real makers using Scanwow in
            the wild.
          </p>
        </div>

        <div className={css.blog}>
          <div className={css.imageWrapper} onClick={() => history.push('/coming-soon')}>
            <img src={blog3} className={css.blogImage} />
            <div className={css.searchHover}>
              <SearchIcon className={css.searchIcon} />
            </div>
          </div>

          <div className={css.blogText}>
            <p className={css.blogTitle} onClick={() => history.push('/coming-soon')}>
              ScanWow: The Marketplace Turning the World Into 3d Assets
            </p>
            <p className={css.blogDescription}>
              ScanWow is the global hub for high-quality 3d assets — where creators can scan, share,
              and sell their work. From cutting-edge scanning formats to an international creator
              community, discover how we’re making digital creation more open, collaborative, and
              profitable for everyone.
            </p>
          </div>
        </div>

        {/* <div className={css.blog}>
          <div className={css.imageWrapper}>
            <img
              src={blog2}
              className={css.blogImage}
              onClick={() => history.push('/coming-soon')}
            />
            <div className={css.searchHover}>
              <SearchIcon className={css.searchIcon} />
            </div>
          </div>
          <div className={css.blogText}>
            <p className={css.blogTitle} onClick={() => history.push('/coming-soon')}>
              Scan smarter, not harder: 5 ways to use 3d scan data in your next project
            </p>
            <p className={css.blogDescription}>
              Tips and use cases for integrating scan data into virtual production, game design, and
              XR workflows.
            </p>
          </div>
        </div> */}

        <div className={css.visit}>
          <p>Visit the blog!</p>

          <button
            type="button"
            onClick={() => history.push('/blog')}
            className={css.quickActionButton}
          >
            <span>More News</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogSection;
